export default class ConfirmationUtil {

  static _setVisible: any;

  static _accept: any;

  static _reject: any;

  static text = 'Confirma essa operação?';

  // constructor() {

  // }

  static confirm(accept: any, reject: any, text = 'Confirma essa operação?') {
    ConfirmationUtil._accept = accept;
    ConfirmationUtil._reject = reject;
    ConfirmationUtil._show();
    ConfirmationUtil.text = text;
  }


  static accept() {
    ConfirmationUtil._accept();
    ConfirmationUtil._hide();
  }

  static reject() {
    if (ConfirmationUtil._reject) {
      ConfirmationUtil._reject();
    }
    ConfirmationUtil._hide();
  }

  static _show() {
    ConfirmationUtil._setVisible(true);
  }

  static _hide() {
    ConfirmationUtil._setVisible(false);
  }

  static init(setVisible: any) {
    ConfirmationUtil._setVisible = setVisible;
  }
}
